(function(){

  var loadScript = function(url, callback){
   
    var script = document.createElement("script");
    script.type = "text/javascript";

    // If the browser is Internet Explorer.
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    // For any other browser.
    } else {
      script.onload = function(){
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
      
  };

  var westgarthProductMeta = function($){
    
     $(document).ready(function() { 
        console.log('westgarthProductMeta....');
        console.log('Shopify', Shopify);

        var productId = $('body').attr('class').split(' ').pop();
        var variantionId = Shopify.queryParams.variant || getParameterByName('variant');
        
        // var productMeta = getMeta('product', productId, variantionId, displayMeta);
        // var variantsMeta = getMeta('variantion', productId, variantionId, displayMeta);


     });

     function displayMeta(meta, level){
      console.log(level + ' meta :', meta);
     }

     function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

     function getMeta(level, productId, variantionId, callback) {
      // Get raw products via API
      // /admin/products/#{id}/variants/#{id}/metafields.json
      if(level == 'product'){
        // /admin/products/#{id}/metafields.json
        var endpointURL = '/admin/products/'+ productId +'/metafields.json';  
      }else{
        var endpointURL = '/admin/products/'+ productId +'/variants/'+variantionId+'/metafields.json';  
      }
        
      console.log('endpointURL', endpointURL);
      var params = {
        type: 'GET',
        url: endpointURL,
        headers: {"X-Shopify-Storefront-Access-Token": "7e46fa9713f7da0f29874f6202a9979a"},
        data: { limit: 10 }, 
        dataType: 'json',
        success: function(metaResults) {
          if ((typeof callback) === 'function') {
            console.log(level + ' meta: ', metaResults);
            callback(metaResults, level);
          }
          else {
            console.log('without callback' + level + ': ', metaResults);
          }
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {              
          console.log(XMLHttpRequest, textStatus, errorThrown);
        }
      };
      $.ajax(params);
     }
  };

  if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
      jQuery191 = jQuery.noConflict(true);
      westgarthProductMeta(jQuery191);
    });
  } else {
    westgarthProductMeta(jQuery);
  }

})();